
import type { GetPaymentRequestsParamsFilters } from '@/modern/modules/m-accounting-module/services/types/payment-requests.types'

import { defineComponent, onBeforeMount, reactive } from 'vue'

// > legacy/types/couriers <
import { DispatcherCourierT } from '@/core/types/couriers.types'

// > legacy/types/carriers <
import { CarrierT } from '@/core/types/carriers.types'

// > legacy/realisations/couriers <
import { couriers } from '@/core/realisations/couriers.realisation'

// > legacy/realisations/carriers <
import { carriers } from '@/core/realisations/carriers.realisation'

const PAYMENT_TYPES = [
    { id: 1, name: 'Оплата наличными' },
    { id: 2, name: 'Оплата переводом' }
]

const STATUSES = [
    { id: 60, name: 'Оплачен' },
    { id: 61, name: 'Отказ от оплаты' },
    { id: 62, name: 'Ожидает оплаты' }
]

export default defineComponent({
    props: {
        loading: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['submit', 'reset'],
    setup(props, { emit }) {
        const state = reactive({
            dateFrom: null as string | null,
            dateTo: null as string | null,
            id: null as string | null,
            statusIds: [] as number[],
            totalAmountFrom: null as string | null,
            totalAmountTo: null as string | null,
            //
            paymentTypeId: null as number | null,
            companyId: null as number | null,
            courierId: null as number | null,
        })

        const data_state = reactive({
            carriers: {
                isLoading: false,
                isFailed: false,
                list: [] as CarrierT[]
            },
            couriers: {
                isLoading: false,
                isFailed: false,
                list: [] as DispatcherCourierT[]
            },
        })

        const loadCarriers = async () => {
            try {
                data_state.carriers.isLoading = true

                const response = await carriers.getList({ page: 1, limit: 9999, statusId: 2 })

                data_state.carriers.list = response.data

                data_state.carriers.isFailed = false
            } catch (error) {
                console.error(error)
                data_state.carriers.isFailed = true
            } finally {
                data_state.carriers.isLoading = false
            }
        }

        const loadCouriers = async () => {
            try {
                data_state.couriers.isLoading = true

                const response = await couriers.getList({ page: 1, limit: 9999 })

                data_state.couriers.list = response.data

                data_state.couriers.isFailed = false
            } catch (error) {
                console.error(error)
                data_state.couriers.isFailed = true
            } finally {
                data_state.couriers.isLoading = false
            }
        }

        onBeforeMount(() => {
            loadCarriers()
            loadCouriers()
        })

        const onSubmit = () => {
            if (props.loading) return

            const params: GetPaymentRequestsParamsFilters = {
                dateFrom: state.dateFrom,
                dateTo: state.dateTo,
                id: state.id,
                // companyId: state.companyId,
                // courierId: state.courierId,
                statusIds: state.statusIds,
                // paymentTypeId: state.paymentTypeId,
                totalAmountFrom: state.totalAmountFrom,
                totalAmountTo: state.totalAmountTo
            }

            emit('submit', params)
        }

        const onReset = () => {
            if (props.loading) return

            state.dateFrom = null
            state.dateTo = null
            state.statusIds = []
            state.totalAmountFrom = null
            state.totalAmountTo = null

            state.paymentTypeId = null
            state.companyId = null
            state.courierId = null

            emit('reset')
        }

        return {
            PAYMENT_TYPES,
            STATUSES,
            state,
            data_state,
            loadCarriers,
            loadCouriers,
            onSubmit,
            onReset
        }
    }
})
